function ContactInfo(el) {
  var mapContainer = el.querySelector('[data-map]');
  if( mapContainer ) {
    var mapLat = mapContainer.getAttribute('data-lat'),
        mapLng = mapContainer.getAttribute('data-lng');
    if( mapLat && mapLng ) {
      var styles = [
        {
          featureType: "poi.business",
          elementType: "labels",
          stylers: [
            { visibility: "off" }
          ]
        }
      ];
      var mapProp = {
        center: new google.maps.LatLng(mapLat,mapLng),
        zoom: 15,
        mapTypeControl: false
      };
      var map = new google.maps.Map(mapContainer,mapProp);
      map.setOptions({styles: styles});
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(mapLat,mapLng),
        map: map,
      });
    }
  }
}

module.exports = ContactInfo;